import React from 'react';
import { Card } from '../ui/Card';
import { FileText, ShieldCheck, PhoneCall } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  icon: FileText,
  title: 'Completezi 6 întrebări',
  description: 'Răspunzi la câteva întrebări simple despre compania ta pentru a determina eligibilitatea inițială.',
  color: 'bg-blue-100 text-blue-600'
}, {
  icon: ShieldCheck,
  title: 'Primești eligibilitatea',
  description: 'Sistemul nostru analizează datele și îți prezintă instant băncile care se potrivesc profilului tău.',
  color: 'bg-indigo-100 text-indigo-600'
}, {
  icon: PhoneCall,
  title: 'Banca te contactează',
  description: 'Primești oferta fermă direct de la bancă și finalizezi procesul de creditare rapid.',
  color: 'bg-emerald-100 text-emerald-600'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-slate-50" data-id="element-143">
      <div className="container mx-auto px-4 md:px-6" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-146">
            Cum funcționează
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-147">
            Am simplificat procesul de creditare la maxim. Doar 3 pași simpli te
            despart de finanțarea dorită.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-148">
          {/* Connector Line (Desktop only) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-200 -z-10" data-id="element-149" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} data-id="element-150">
              <div className="flex flex-col items-center text-center" data-id="element-151">
                <div className={`w-24 h-24 rounded-2xl ${step.color} flex items-center justify-center mb-6 shadow-sm border border-white`} data-id="element-152">
                  <step.icon className="h-10 w-10" data-id="element-153" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-154">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-155">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}